import * as types from './actionTypes';

export const open = ({ quoteItemIds }: { quoteItemIds: number[] }) => ({
  type: types.OPEN,
  payload: { quoteItemIds },
});

export const close = () => ({
  type: types.CLOSE,
});
